import {Component, OnInit, SimpleChange} from '@angular/core';
import { StoreFsrhDetailsService } from '../services/store-fsrh-details.service';
import * as $ from 'jquery';
import {b} from '@angular/core/src/render3';
import {FormControl} from '@angular/forms';
import { ViewChild } from '@angular/core';
import { MatCheckbox } from '@angular/material';
import { MatSlider } from '@angular/material';
import {StringDecoder} from "string_decoder";
import { NativeDateAdapter } from '@angular/material';
import { RouterModule, Routes } from '@angular/router';

$('<br />').insertBefore('.danger');


@Component({
  selector: 'app-fsrh',
  templateUrl: './fsrh.component.html',
  styleUrls: ['./fsrh.component.scss?1']
 })


export class FsrhComponent implements OnInit {


  @ViewChild('myCheckbox') myCheckbox: MatCheckbox;
  message = new FormControl('Info about the action');
  oneDayInMs = 86400000;
  lessThan96 = Date.now() - (this.oneDayInMs * 4);
  lessThan120 = Date.now() - (this.oneDayInMs * 5);
  maxDateForCycleLength = new Date();
  currentMonth= new Date();
  previousMonth= new Date((this.currentMonth.getTime() - (31 * this.oneDayInMs)));
  timeSinceUPSI: string;
  useOfCuIUD: boolean;
  firstDayOfLastPeriod: Date;
  cycleLength: number;
  firstDayOfOvulation: Date;
  additionalUpsiThisCycle: boolean;
  breastFeeding: boolean;
  upsi5DaysPriorOvulation: boolean;
  OvulationCheck: boolean;
  wasPeriodNormal: boolean;
  usingHormonalContraception: boolean;
  takingNoneOfAbove:boolean =false;
  bmi: any;
  bmiDetails;
  bmiRedDetails;
  maxHeight = 210;
  minHeight = 140;
  maxWeight = 132;
  minWeight = 40;
  daysSincePeriod;
  hasCalculated = false;
  HRT = false;
  daysSince = [
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
    { value: 5, label: '5' },
    { value: 6, label: '6' },
    { value: 7, label: '7' },
    { value: 8, label: '8' },
    { value: 9, label: '9' },
    { value: 10, label: '10' },
    { value: 11, label: '11' },
    { value: 12, label: '12' },
    { value: 13, label: '13' },
    { value: 14, label: '14' },
    { value: 15, label: '15' },
    { value: 16, label: '16' },
    { value: 17, label: '17' },
    { value: 18, label: '18' },
    { value: 19, label: '19' },
    { value: 20, label: '20' },
    { value: 21, label: '21' },
    { value: 22, label: '22' },
    { value: 23, label: '23' },
    { value: 24, label: '24' },
    { value: 25, label: '25' },
    { value: 26, label: '26' },
    { value: 27, label: '27' },
    { value: 28, label: '28' },
    { value: 29, label: '29' },
    { value: 30, label: '30' },
    { value: 31, label: '31' },
    { value: 32, label: '32' },
    { value: 33, label: '33' },
    { value: 34, label: '34' },
    { value: 35, label: '35' },
    { value: 36, label: '36' },
    { value: 37, label: '37' },
    { value: 38, label: '38' },
    { value: 39, label: '39' },
    { value: 40, label: '40' },
    { value: 41, label: '41' },
    { value: 42, label: '42' },
    { value:43, label: '43' },
    { value:44, label: '44' },
    { value:45, label: '45' },
    { value:46, label: '46' },
    { value:47, label: '47' },
    { value:48, label: '48' },
    { value:49, label: '49' },
    { value:50, label: '50' },
    { value:51, label: '51' },
    { value:52, label: '52' },
    { value:53, label: '53' },
    { value:54, label: '54' },
    { value:55, label: '55' },
    { value:56, label: '56' },
    { value:57, label: '57' },
    { value:58, label: '58' },
    { value:59, label: '59' },
    { value:60, label: '60' },
    { value:61, label: '61' },
    { value:62, label: '62' },
    { value:63, label: '63' },
    { value:64, label: '64' },
    { value:65, label: '65' },
    { value:66, label: '66' },
    { value:67, label: '67' },
    { value:68, label: '68' },
    { value:69, label: '69' },
    { value:70, label: '70' },
    { value:71, label: '71' },
    { value:72, label: '72' },
    { value:73, label: '73' },
    { value:74, label: '74' },
    { value:75, label: '75' },
    { value:76, label: '76' },
    { value:77, label: '77' },
    { value:78, label: '78' },
    { value:79, label: '79' },
    { value:80, label: '80' },
    { value:81, label: '81' },
    { value:82, label: '82' },
    { value:83, label: '83' },
    { value:84, label: '84' },
    { value:85, label: '85' },
    { value:86, label: '86' },
    { value:87, label: '87' },
    { value:88, label: '88' },
    { value:89, label: '89' },
    { value:90, label: '90' },
    { value:91, label: '91' },
    { value:92, label: '92' },
    { value:93, label: '93' },
    { value:94, label: '94' },
    { value:95, label: '95' },
    { value:96, label: '96' },
    { value:97, label: '97' },
    { value:98, label: '98' },
    { value:99, label: '99' },
    { value:100, label: '100' }

  ];

  days = [
    { value: 20, label: '20' },
    { value: 21, label: '21' },
    { value: 22, label: '22' },
    { value: 23, label: '23' },
    { value: 24, label: '24' },
    { value: 25, label: '25' },
    { value: 26, label: '26' },
    { value: 27, label: '27' },
    { value: 28, label: '28' },
    { value: 29, label: '29' },
    { value: 30, label: '30' },
    { value: 31, label: '31' },
    { value: 32, label: '32' },
    { value: 33, label: '33' },
    { value: 34, label: '34' },
    { value: 35, label: '35' },
    { value: 36, label: '36' },
    { value: 37, label: '37' },
    { value: 38, label: '38' },
    { value: 39, label: '39' },
    { value: 40, label: '40' },
    { value: 41, label: '41' },
    { value: 42, label: '42' },
    { value:43, label: '43' },
    { value:44, label: '44' },
    { value:45, label: '45' },
    { value:46, label: '46' },
    { value:47, label: '47' },
    { value:48, label: '48' },
    { value:49, label: '49' },
    { value:50, label: '50' },
    { value:51, label: '51' },
    { value:52, label: '52' },
    { value:53, label: '53' },
    { value:54, label: '54' },
    { value:55, label: '55' },
    { value:56, label: '56' },
    { value:57, label: '57' },
    { value:58, label: '58' },
    { value:59, label: '59' },
    { value:60, label: '60' },
    { value:61, label: '61' },
    { value:62, label: '62' },
    { value:63, label: '63' },
    { value:64, label: '64' },
    { value:65, label: '65' },
    { value:66, label: '66' },
    { value:67, label: '67' },
    { value:68, label: '68' },
    { value:69, label: '69' },
    { value:70, label: '70' },
    { value:71, label: '71' },
    { value:72, label: '72' },
    { value:73, label: '73' },
    { value:74, label: '74' },
    { value:75, label: '75' },
    { value:76, label: '76' },
    { value:77, label: '77' },
    { value:78, label: '78' },
    { value:79, label: '79' },
    { value:80, label: '80' },
    { value:81, label: '81' },
    { value:82, label: '82' },
    { value:83, label: '83' },
    { value:84, label: '84' }


  ];
  heightMetric = 'cm';
  heightEntered;
  weightMetric = 'kg';
  weightEntered;
  feetRange = [
    { name: '4', value: 4 },
    { name: '5', value: 5 },
    { name: '6', value: 6 }
  ];
  inchRange = [
    { name: '0', value: 0 },
    { name: '1', value: 1 },
    { name: '2', value: 2 },
    { name: '3', value: 3 },
    { name: '4', value: 4 },
    { name: '5', value: 5 },
    { name: '6', value: 6 },
    { name: '7', value: 7 },
    { name: '8', value: 8 },
    { name: '9', value: 9 },
    { name: '10', value: 10 },
    { name: '11', value: 11 },
  ];
  stoneRange = [
    { name: '6', value: 6 },
    { name: '7', value: 7 },
    { name: '8', value: 8 },
    { name: '9', value: 9 },
    { name: '10', value: 10 },
    { name: '11', value: 11 },
    { name: '12', value: 12 },
    { name: '13', value: 13 },
    { name: '14', value: 14 },
    { name: '15', value: 15 },
    { name: '16', value: 16 },
    { name: '17', value: 17 },
    { name: '18', value: 18 },
    { name: '19', value: 19 },
    { name: '20', value: 20 }
  ];
  lbRange = [
    { name: '0', value: 0 },
    { name: '1', value: 1 },
    { name: '2', value: 2 },
    { name: '3', value: 3 },
    { name: '4', value: 4 },
    { name: '5', value: 5 },
    { name: '6', value: 6 },
    { name: '7', value: 7 },
    { name: '8', value: 8 },
    { name: '9', value: 9 },
    { name: '10', value: 10 },
    { name: '11', value: 11 },
    { name: '12', value: 12 },
    { name: '13', value: 13 },
  ];
  feet;
  inches;
  stone;
  lb;
  daysSinceLikelyDateOfOvulation;
  fiveDaysPriorOvulationDate = new Date();
  fiveDaysAfterOvulationDate = new Date();
  outcomeResult;
  weightInKg;
  within5DaysAfterOvulation: boolean;
  today = new Date();
  takingEnzymeInducer: boolean = false;
  recentConsumptionOfProgestogen;
  asthmaManagedWithglucocorticoids: boolean = false;
  takingCOC = false;
  takingPOP = false;
  takingImplant = false;
  takingDepo = false;
  takingIntrauterine = false;
  takingPatchorRing = false;
  takingHormonalMethods = false;
  testText: string;
  yetToOvulate: boolean;
  errorHeightString;
  errorWeightString;


  constructor(private storeFsrhDetails: StoreFsrhDetailsService) {
    this.today.setHours(0, 0, 0, 0);
    this.maxDateForCycleLength.setDate(this.maxDateForCycleLength.getDate());
    storeFsrhDetails.removeLocalStorageVariables();
  }


  getFirstDayOfLastPeriod = () => {
    this.firstDayOfLastPeriod= new Date(this.today.getTime() - (this.daysSincePeriod * this.oneDayInMs));

    this.ovulationCalculator();
  }
  getDaysSinceLastPeriod = () => {
    this.daysSincePeriod = (this.today.getTime() - this.firstDayOfLastPeriod.getTime())/this.oneDayInMs;
    this.ovulationCalculator();
  }
  reloadPage = () => {
    location.reload();
  }

  ovulationCalculator = () => {
    if(this.firstDayOfLastPeriod===undefined || this.cycleLength===undefined){

    }
    else{
    this.yetToOvulate = false;
    this.firstDayOfOvulation = new Date();
    this.firstDayOfOvulation.setTime(this.firstDayOfLastPeriod.getTime() + ((this.cycleLength * this.oneDayInMs) - (14 * this.oneDayInMs)));
    this.fiveDaysPriorOvulationDate = new Date();
    this.fiveDaysPriorOvulationDate.setTime(Math.floor(this.firstDayOfOvulation.getTime() - (5 * this.oneDayInMs)));
    this.fiveDaysAfterOvulationDate = new Date();
    this.fiveDaysAfterOvulationDate.setTime(Math.floor(this.firstDayOfOvulation.getTime() + (5 * this.oneDayInMs)));
    this.daysSinceLikelyDateOfOvulation = Math.floor((Date.now() - this.firstDayOfOvulation.getTime()) / this.oneDayInMs);
    if (this.today.getTime() >= this.firstDayOfOvulation.getTime() && this.today.getTime() <= this.fiveDaysAfterOvulationDate.getTime()) {
      this.within5DaysAfterOvulation = true;
    } else {
      this.within5DaysAfterOvulation = false;
    }

    if(this.firstDayOfOvulation.getTime()<=(this.today.getTime()-(21*this.oneDayInMs))){

      this.storeFsrhDetails.wasPeriodNormal = false;
      window.location.href="http://ecwebdev.health4women.ie/#/taking-hormonal-contraception";

    }
    this.upsi5DaysPriorCheck();
    return this.firstDayOfOvulation;

  }}
  setPatientResults = () => {
    const content = document.getElementById('patientDets');
    localStorage.setItem('patientDets',  content.innerHTML);
  }
  upsi5DaysPriorCheck = () => {
   if(this.firstDayOfOvulation.getTime()>=this.today.getTime()) {
      if(this.fiveDaysPriorOvulationDate.getTime()<=(this.today.getTime()) &&(this.timeSinceUPSI === '<96' || this.timeSinceUPSI === '<120')){
       this.within5DaysAfterOvulation = true;
       this.upsi5DaysPriorOvulation = true;
       this.OvulationCheck = true;
       console.log("working 1");
     }
   else {
       this.within5DaysAfterOvulation = false;
       this.OvulationCheck = true;
       this.upsi5DaysPriorOvulation = false;
       console.log("working 2");

   }}
   }

  calculateBMI = () => {
    let height, weight;

    if ((this.feet===undefined&&this.heightEntered===undefined)||(this.stone===undefined&&this.weightEntered===undefined)||this.hasCalculated===false) {

    }
   else{

    if (this.heightMetric === 'ft') {
      if(this.feet === undefined){
        this.feet=0;
      }
      if(this.inches === undefined){
        this.inches =0;
      }
      this.heightEntered = ((this.feet * 30.48) + (this.inches * 2.54));
    }
       this.errorHeightString = undefined;
        height = this.heightEntered / 100;
    if (height < (this.minHeight / 100) || height > (this.maxHeight / 100) ) {
      this.errorHeightString = '*Invalid height';
      return;
    }


    if (this.weightMetric === 'stn') {
      if(this.stone === undefined){
        this.stone=0;
      }
      if(this.lb === undefined){
        this.lb =0;
      }
      this.weightEntered = ((this.stone * 6.350293) + (this.lb * 0.4535924));
    }
        this.errorWeightString = undefined;
        weight = this.weightEntered;
        this.weightInKg = weight;

    if (weight < this.minWeight || weight > this.maxWeight) {
      this.errorWeightString = '*Invalid weight';
      return;
    }


      this.bmi = (weight / (height * height)).toFixed(2);

    if(this.bmi>26){
      this.bmiDetails="";
      this.bmiRedDetails = 'H: ' + this.heightEntered.toFixed(0) + 'cm';
      this.bmiRedDetails += ' W: ' + this.weightEntered.toFixed(0) + 'kg';
      this.bmiRedDetails += ' BMI: ' + this.bmi;
      this.bmiRedDetails += ' \nBMI is greater than 26';
      }

  else {
    this.bmiRedDetails="";
      this.bmiDetails = 'H: ' + this.heightEntered.toFixed(0) + 'cm';
      this.bmiDetails += ' W: ' + this.weightEntered.toFixed(0) + 'kg';
      this.bmiDetails += ' BMI: ' + this.bmi;
    }
  }}
  setRecentConsumptionOfProgestogenToTrue = () => {
    this.recentConsumptionOfProgestogen = true;

  }
  setRecentConsumptionOfProgestogenToFalse = () => {
    this.recentConsumptionOfProgestogen = false;

  }


  setCOC = () => {
    this.storeFsrhDetails.takingCOC = true;
    this.storeFsrhDetails.wasPeriodNormal = true;
  }
  setPOP = () => {
    this.storeFsrhDetails.takingPOP = true;
    this.storeFsrhDetails.wasPeriodNormal = true;
  }
  setImplant = () => {
    this.storeFsrhDetails.takingImplant = true;
    this.storeFsrhDetails.wasPeriodNormal = true;
  }
  setDepo = () => {
    this.storeFsrhDetails.takingDepo = true;
    this.storeFsrhDetails.wasPeriodNormal = true;
  }
  setPatchOrRing = () => {

    this.storeFsrhDetails.takingPatchorRing = true;
    this.storeFsrhDetails.wasPeriodNormal = true;
  }
  setIntrauterine = () => {
    this.storeFsrhDetails.takingIntrauterine = true;
    this.storeFsrhDetails.wasPeriodNormal = true;
  }

  submit = () => {
    this.myCheckbox.checked = false;
  }

  getToTop = () => {
    if (window.innerWidth < 800){
    window.location.href = '#top';
    }
    else{
      window.location.href = '#veryTop';
    }
  }
  getToWarning = () => {
    if (window.innerWidth < 800) {
      window.location.href = '#topToWarning';
    }
    else{
      window.location.href = '#veryTop';
    }
  }
  checkDayOfOvualtion = () => {
     var fivedays = this.today.getTime() - this.firstDayOfOvulation.getTime();

     if(fivedays>0){
       return this.firstDayOfOvulation.getTime();
     }
     else{
       return this.firstDayOfOvulation.getTime()+fivedays;
     }
  }
  determineOutcome = () => {
    this.storeFsrhDetails.removeLocalStorageVariables();
    // Algo 1
    if (this.timeSinceUPSI === '<120' || this.timeSinceUPSI === '<96') {
      if (this.additionalUpsiThisCycle && (this.within5DaysAfterOvulation || this.yetToOvulate)) {
        this.storeFsrhDetails.formResult1 = 1;
        this.storeFsrhDetails.eligibleForCuIUD = true;
      } else if (this.additionalUpsiThisCycle && !this.within5DaysAfterOvulation) {
        this.storeFsrhDetails.formResult1 = 2;
        this.storeFsrhDetails.pregnancyTestAdvised = true;
      } else if (!this.additionalUpsiThisCycle) {
        this.storeFsrhDetails.formResult1 = 3;
        this.storeFsrhDetails.eligibleForCuIUD = true;
      }
    } else if (this.timeSinceUPSI === '>120') {
      if (this.within5DaysAfterOvulation || this.yetToOvulate) {
        this.storeFsrhDetails.formResult1 = 4;
        this.storeFsrhDetails.oralECUnlikelyEffective = true;
        this.storeFsrhDetails.offerQuickStartContraception = true;
        this.storeFsrhDetails.eligibleForCuIUD = true;
      } else if (!this.within5DaysAfterOvulation) {
        this.storeFsrhDetails.formResult1 = 5;
        this.storeFsrhDetails.oralECUnlikelyEffective = true;
        this.storeFsrhDetails.offerQuickStartContraception = true;
      }
    } else if (this.timeSinceUPSI === 'unknown') {
      if (this.within5DaysAfterOvulation || this.yetToOvulate) {
        this.storeFsrhDetails.formResult1 = 6;
        this.storeFsrhDetails.eligibleForCuIUD = true;
      } else if (!this.within5DaysAfterOvulation) {
        this.storeFsrhDetails.formResult1 = 7;
      }
    }

    // Algo 2

      if (this.timeSinceUPSI === '<96') {
        if (this.upsi5DaysPriorOvulation) {
          this.storeFsrhDetails.formResult2 = 8;
        } else if (!this.upsi5DaysPriorOvulation) {
          if (this.bmi > 26 || this.weightInKg > 70) {
            this.storeFsrhDetails.formResult2 = 9;
          } else {
            this.storeFsrhDetails.formResult2 = 10;
          }
        }
      } else {
        if (this.timeSinceUPSI === '>120') {
          this.storeFsrhDetails.formResult2 = 11;
        } else {
          this.storeFsrhDetails.formResult2 = 12;
        }
      }

    this.outcomeResult = this.storeFsrhDetails.formResult1;
    this.storeFsrhDetails.takingEnzymeInducer = this.takingEnzymeInducer;
    this.storeFsrhDetails.asthmaManagedWithglucocorticoids = this.asthmaManagedWithglucocorticoids;
    this.storeFsrhDetails.bmi = this.bmi;
    this.storeFsrhDetails.weightInKg = this.weightInKg;
    this.storeFsrhDetails.patientDets = this.testText;
    this.storeFsrhDetails.useOfCuIUD = this.useOfCuIUD;
    this.storeFsrhDetails.wasPeriodNormal = this.wasPeriodNormal;
    this.storeFsrhDetails.within5DaysAfterOvulation = this.within5DaysAfterOvulation;
    this.storeFsrhDetails.today = this.today.getTime();
    this.storeFsrhDetails.fiveDaysAfterOvulationDate = this.fiveDaysAfterOvulationDate.getTime();
    this.storeFsrhDetails.breastFeeding = this.breastFeeding;
    this.storeFsrhDetails.HRT = this.HRT;

  }
  ngOnInit() {
    $(document).ready(function() {
      $('.btn').click(function() {

      });
    });
  }
}


export class CustomDateAdapter extends NativeDateAdapter {

getFirstDayOfWeek(): number {
  return 1;
}
}
